import Flow from '../Flow';
const FlowSchemaValidateInput = Symbol('validateInput');
export default class FlowSchema {
    constructor(schema) {
        this.schema = schema;
        FlowSchema[FlowSchemaValidateInput](schema);
    }
    static [FlowSchemaValidateInput](schema) {
        if (typeof schema !== 'object' ||
            schema === null ||
            Array.isArray(schema)) {
            throw new TypeError('The argument of the flow schema constructor must be an object');
        }
        Object.keys(schema).map((key) => {
            const u = schema[key];
            if (!(u instanceof Flow || u instanceof FlowSchema)) {
                throw new TypeError('Each key of a FlowSchema must be a Flow or another FlowSchema');
            }
        });
    }
}
